export default "__VITE_ASSET__8969e3b1__"